/* eslint-disable max-len */
import * as React from 'react';
import { useSelector } from 'react-redux';
import {
  DateField,
  Show,
  SimpleShowLayout,
  TextField,
} from 'react-admin';
import { Grid } from '@mui/material';
import ShowLabel from '../../../components/commons/showLabel';
import ShowActions from '../../../components/commons/showActions';
import canAccess from '../../../utils/canAccess';
import FUNC from '../../../utils/functions';
import PasswordTextField from '../../../components/commons/passwordTextField';

export default React.memo(() => {
  const { permissions } = useSelector((state: any) => state.app.appState);
  const canPut = canAccess(permissions, FUNC.EDIT_API_KEY);
  const canSearch = canAccess(permissions, FUNC.SEARCH_API_KEYS);
  return (
    <Show
      actions={<ShowActions isEdit={canPut} isList={canSearch} />}
    >
      <SimpleShowLayout>
        <Grid container spacing={2} rowSpacing={0.5}>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.moduleId" />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="moduleId"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.name" />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              source="name"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.aud" />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="aud"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.key" />
          </Grid>
          <Grid item xs={8} md={10}>
            <PasswordTextField source="key" className="alignItems-class" />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.loginKey" />
          </Grid>
          <Grid item xs={8} md={10}>
            <PasswordTextField source="loginKey" className="alignItems-class" />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.secret" />
          </Grid>
          <Grid item xs={8} md={10}>
            <PasswordTextField source="secret" className="alignItems-class" />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.description" />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="description"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.redirectUrl" />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="redirectUrl"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.appRedirectUrl" />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="appRedirectUrl"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.iss" />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="iss"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.crossOrigin" />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="crossOrigin"
            />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.from" />
          </Grid>
          <Grid item xs={8} md={10}>
            <DateField fullWidth source="from" showTime />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.to" />
          </Grid>
          <Grid item xs={8} md={10}>
            <DateField fullWidth source="to" showTime />
          </Grid>
          <Grid item xs={1} md={2} sx={{ borderBottom: '1' }}>
            <ShowLabel label="resources.integration/api-keys.fields.env" />
          </Grid>
          <Grid item xs={8} md={10}>
            <TextField
              fullWidth
              source="env"
            />
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
});
